import { useState } from 'react'

import { EMPTY_FUNCTION_ASYNC } from '../../../../constants/common'
import { UserProfileWidgetOragCluster } from '../../../User'
import { Component, ComponentProps } from '../../Component'
import { boolean, controls, json } from '../../Controls'
import { MOCK_INFO_OPTIONS } from '../InhabitantProfile.constants'

import { PROFILE_ORAG_CLUSTER_INHABITANT_DATA } from './ProfileOragClusterWidgetInhabitant.constants'

function ProfileOragClusterWidgetInhabitant() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('canEdit', true))
      .add(json('data', PROFILE_ORAG_CLUSTER_INHABITANT_DATA))
      .add(boolean('isSkeleton', false))
      .add(json('options', MOCK_INFO_OPTIONS))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={UserProfileWidgetOragCluster}
        name='UserProfileWidgetOragCluster'
        onSubmit={EMPTY_FUNCTION_ASYNC}
      />
      <ComponentProps
        name='UserProfileWidgetOragCluster'
        value={props}
        onChange={setProps}
      />
    </>
  )
}

export default ProfileOragClusterWidgetInhabitant
